{
    "userProfile": {
        "title": "My Profile",
        "menu": {
            "profile": "Personal Information",
            "companies": "My Companies",
            "invoices": "Invoices"
        },
        "personalData": {
            "title": "Personal Data"
        },
        "companyData": {
            "title": "Company Data"
        },
        "update": {
            "success": {
                "message": "Your profile has been successfully updated"
            },
            "error": {
                "message": "There was a problem updating your profile. Please try again."
            }
        }
    },
    "myCompanies": {
        "title": "My Companies",
        "buttons": {
            "addCompany": "Add Company"
        },
        "table": {
            "companyNameColumn": "Company Name",
            "countryCodeColumn": "Country Code",
            "addressColumn": "Address",
            "zipColumn": "ZIP",
            "cityColumn": "City",
            "statusColumn": "Status",
            "tinColumn": "TIN / VAT"
        }
    },
    "addressBook": {
        "title": "Address book",
        "buttons": {
            "addNewContact": "Add new contact"
        },
        "table": {
            "countryColumn": "Country Name",
            "companyColumn": "Company Name",
            "contactColumn": "Contact Person",
            "phoneNumberColumn": "Phone Number",
            "emailColumn": "Email"
        }
    },
    "myOrders": {
        "title": "My orders",
        "buttons": {
            "addNewOrder": "Add new order"
        },
        "status": {
            "processing": "Processing",
            "confirmed": "Confirmed",
            "scheduledLoading": "Scheduled Loading",
            "loaded": "Loaded",
            "inTransit": "In Transit",
            "customsRegistration": "Customs Registration",
            "delivered": "Delivered",
            "cancelled": "Cancelled"
        },
        "table": {
            "orderColumn": "Orders",
            "dataColumn": "Data",
            "senderColumn": "Sender",
            "recipientColumn": "Recipient",
            "routeColumn": "Route",
            "uploadDateColumn": "Upload date",
            "deliveryDateColumn": "Delivery date",
            "statusColumn": "Status"
        }
    },
    "selectedOrder": {
        "title": "Order",
        "menu": {
            "order": "Order",
            "documents": "Documents",
            "invoices": "Invoices"
        }
    },
    "orderStatusPanel": {
        "title": {
            "summary": "Summary"
        },
        "columns": {
            "creationDate": "Creation date"
        }
    },
    "documents": {
        "title": "Documents",
        "table": {
            "fileNameColumn": "File Name",
            "typeColumn": "Type",
            "documentNumberColumn": "Document Number",
            "orderNumberColumn": "Order Number",
            "documentDateColumn": "Document Date",
            "createdColumn": "Created",
            "fileSizeColumn": "File Size",
            "actionsColumn": "Actions"
        },
        "buttons": {
            "uploadDocument": "Upload Document"
        }
    },
    "invoices": {
        "title": "Invoices",
        "status": {
            "unpaid": "Unpaid",
            "partiallyPaid": "Partially Paid",
            "paid": "Paid",
            "cancelled": "Cancelled"
        },
        "table": {
            "invoiceNumberColumn": "Invoice Number",
            "orderNumberColumn": "Order Number",
            "sellerColumn": "Seller",
            "invoiceDateColumn": "Invoice Date",
            "dueDateColumn": "Due Date",
            "amountColumn": "Amount",
            "amountPaidColumn": "Amount Paid",
            "statusColumn": "Status",
            "fileSizeColumn": "File Size",
            "actionsColumn": "Actions"
        },
        "buttons": {
            "uploadInvoice": "Upload Invoice"
        }
    },
    "support": {
        "title": "Help & contact",
        "contact": {
            "title": "Your contact to us",
            "button": "Contact form",
            "approxOneHour": "approx. 1 hour",
            "approxFiveMinutes": "approx. 5 minutes",
            "liveChat": "Live chat",
            "highCapacityNote": "Approximately 15 minutes - currently high capacity utilization",
            "averageResponseNote": "* Average response time"
        },
        "solution": {
            "title": "Simply customize your shipment yourself",
            "button": "To the Solution Center"
        }
    },
    "notifications": {
        "title": "Notifications",
        "createdAt": "Date created",
        "subject": "Message subject",
        "noNotifications": "You have no notifications",
        "markAllAsRead": "Mark all as read",
        "tabs": {
            "all": "All",
            "news": "News",
            "system": "System",
            "service": "Service"
        },
        "drawer": {
            "title": "Notification"
        },
        "unreadCount": "{{count}} new"
    },
    "adminPanel": {
        "title": "Admin panel",
        "tabs": {
            "changeRequests": "Change Requests",
            "notifications": "Notifications",
            "exchangeRates": "Exchange Rates",
            "tariffUploader": "Uploading Rates",
            "tariffSurcharges": "Tariff Surcharges",
            "proposals": "Proposals",
            "orders": "Orders",
            "allDocuments": "Documents",
            "allInvoices": "Invoices",
            "users": "Users"
        },
        "users": {
            "search": "Search users",
            "table": {
                "name": "Name",
                "email": "Email",
                "roles": "Roles",
                "emailConfirmed": "Email confirmed",
                "status": "Status",
                "actions": "Actions"
            },
            "status": {
                "active": "Active",
                "inactive": "Inactive"
            },
            "values": {
                "yes": "Yes",
                "no": "No"
            },
            "filters": {
                "allStatuses": "All statuses",
                "allRoles": "All roles",
                "allConfirmations": "All email states",
                "confirmed": "Confirmed",
                "unconfirmed": "Unconfirmed"
            },
            "actions": {
                "edit": "Edit user",
                "activate": "Activate",
                "deactivate": "Deactivate"
            },
            "edit": {
                "title": "Edit user",
                "firstName": "First name",
                "lastName": "Last name",
                "email": "Email",
                "phone": "Phone",
                "protectedAdministrator": "Another administrator's data can only be edited by that account owner."
            },
            "details": {
                "publicId": "Public ID",
                "userName": "Username",
                "roles": "Roles",
                "emailConfirmed": "Email confirmed",
                "phoneConfirmed": "Phone confirmed",
                "twoFactor": "Two-factor authentication"
            },
            "statusModal": {
                "activateTitle": "Activate user",
                "deactivateTitle": "Deactivate user",
                "activateMessage": "Activate {{user}}? They will be able to sign in again.",
                "deactivateMessage": "Deactivate {{user}}? Their current sessions will be revoked immediately.",
                "reason": "Reason (optional)"
            },
            "errors": {
                "user-management": {
                    "self-deactivation": "You cannot deactivate your own account.",
                    "self-demotion": "You cannot remove your own Administrator role.",
                    "last-active-administrator": "The last active administrator cannot be deactivated or demoted.",
                    "concurrency-conflict": "Another administrator changed this data. Refresh and try again."
                },
                "forbidden": "You do not have permission to manage users.",
                "generic": "The user could not be updated. Please try again."
            }
        },
        "tariffUploader": {
            "missingDirections": {
                "title": "Some routes were skipped because tariff data is missing",
                "chain": "Route {{departure}}–{{destination}} \"{{title}}\" was skipped. No tariff data for: {{directions}}."
            }
        },
        "allDocuments": {
            "filterByType": "Document type",
            "allTypes": "All types",
            "editDocument": "Edit Document",
            "deleteConfirm": "Are you sure you want to delete this document? This will permanently delete the file.",
            "table": {
                "orderNumber": "Order",
                "client": "Client",
                "fileName": "File name",
                "type": "Type",
                "documentNumber": "Document no.",
                "documentDate": "Document date",
                "created": "Uploaded",
                "fileSize": "Size"
            }
        },
        "allInvoices": {
            "filterByStatus": "Status",
            "statuses": {
                "all": "All statuses",
                "unpaid": "Unpaid",
                "partiallyPaid": "Partially paid",
                "paid": "Paid",
                "cancelled": "Cancelled"
            },
            "editInvoice": "Edit Invoice",
            "deleteConfirm": "Are you sure you want to delete this invoice? This will permanently delete the file.",
            "table": {
                "orderNumber": "Order",
                "client": "Client",
                "invoiceNumber": "Invoice no.",
                "seller": "Seller",
                "invoiceDate": "Invoice date",
                "dueDate": "Due date",
                "amount": "Amount",
                "amountPaid": "Amount paid",
                "status": "Status"
            }
        },
        "tariffSurcharges": {
            "subTabs": {
                "definitions": "Surcharges",
                "tariffTypes": "Tariff type surcharges",
                "selected": "Optional surcharges"
            },
            "form": {
                "unit": "Unit",
                "unitEur": "€ (fixed amount)",
                "unitPct": "% (percentage)",
                "amount": "Amount"
            },
            "tariffTypes": {
                "create": "Add tariff type surcharge",
                "edit": "Edit tariff type surcharge",
                "deleteConfirm": "Are you sure you want to delete this tariff type surcharge?",
                "table": {
                    "type": "Tariff type",
                    "description": "Description",
                    "amount": "Amount"
                }
            },
            "selected": {
                "create": "Add optional surcharge",
                "edit": "Edit optional surcharge",
                "deleteConfirm": "Are you sure you want to delete this optional surcharge?",
                "table": {
                    "alias": "Name",
                    "description": "Description",
                    "amount": "Amount"
                }
            },
            "definitions": {
                "create": "Add surcharge",
                "edit": "Edit surcharge",
                "deleteConfirm": "Are you sure you want to delete this surcharge? All its direction amounts will be removed.",
                "saveToAddDirections": "Save to add direction amounts",
                "directionAmountsTitle": "Direction amounts",
                "directionAmountsHint": "Pick directions below and set each amount inline. Optionally type a value and use Apply to set it for all selected directions at once.",
                "directionsSearchPlaceholder": "Search directions...",
                "selectDirections": "Select directions",
                "selectAllVisible": "Select all visible",
                "clearSelection": "Clear selection",
                "selectedCount": "{{count}} selected",
                "selectedDirectionsTitle": "Selected directions",
                "amountNotSet": "amount not set",
                "noDirections": "No directions found",
                "selectDirectionsError": "Select at least one direction",
                "emptyAmountsError": "Enter an amount for every selected direction before saving.",
                "dimensionAmountsTitle": "Amounts with dimensions",
                "dimensionAmountsHint": "These rows apply only when cargo exceeds the listed thresholds. The dimensions are fixed; you can change the direction and the amount.",
                "dimensionLabel": "L {{length}} × W {{width}} × H {{height}} mm, {{weight}} kg",
                "bulkAmountLabel": "Apply amount to all selected ({{symbol}})",
                "applyToSelected": "Apply",
                "resetChanges": "Reset",
                "unsavedChanges": "You have unsaved changes. Save to apply them or reset to discard.",
                "noAmounts": "No direction amounts yet",
                "table": {
                    "alias": "Name",
                    "description": "Description",
                    "unit": "Unit",
                    "amount": "Amount",
                    "directionsCount": "Directions",
                    "directionsEmpty": "Not configured",
                    "directionsPopoverTitle": "Amounts by direction"
                }
            }
        },
        "notifications": {
            "title": "Notifications management",
            "createNotification": "Create notification",
            "editNotification": "Edit notification",
            "deleteConfirm": "Are you sure you want to delete this notification?",
            "form": {
                "title": "Title",
                "titlePlaceholder": "Enter notification title",
                "content": "Content",
                "contentPlaceholder": "Enter notification content...",
                "type": "Type",
                "selectType": "Select type",
                "targetUser": "Target user (optional)",
                "targetUserPlaceholder": "Leave empty for broadcast",
                "news": "News",
                "system": "System",
                "service": "Service",
                "isGlobal": "Global notification",
                "isGlobalDescription": "Show to all users regardless of their language (with fallback)",
                "atLeastOneTranslation": "At least one language must have title and content filled"
            },
            "table": {
                "title": "Title",
                "type": "Type",
                "targetUser": "Target user",
                "broadcast": "Broadcast",
                "createdAt": "Created",
                "actions": "Actions",
                "languages": "Languages",
                "global": "Global"
            }
        },
        "changeRequests": {
            "title": "Change Requests",
            "filterByStatus": "Filter by status",
            "staleBadge": "Stale",
            "statuses": {
                "all": "All statuses",
                "pending": "Pending",
                "approved": "Approved",
                "rejected": "Rejected"
            },
            "table": {
                "orderNumber": "Order Number",
                "user": "User",
                "status": "Status",
                "changes": "Changes",
                "requestedAt": "Requested",
                "view": "View"
            }
        },
        "rejectModal": {
            "title": "Reject Change Request",
            "reasonLabel": "Reason for rejection",
            "reasonPlaceholder": "Enter the reason for rejecting this change request..."
        },
        "changesSummary": {
            "title": "Requested Changes",
            "showChanges": "Show changes",
            "hideChanges": "Hide changes",
            "fields": {
                "deliveryFrom": "Sender Address",
                "deliveryTo": "Recipient Address",
                "deliveryOption": "Delivery Option",
                "orderCargo": "Cargo",
                "recommendedServices": "Additional Services"
            },
            "properties": {
                "countryCode": "Country Code",
                "countryName": "Country",
                "zip": "ZIP",
                "city": "City",
                "address": "Address",
                "companyName": "Company",
                "contactPerson": "Contact Person",
                "email": "Email",
                "phoneNumber": "Phone",
                "note": "Note",
                "optionType": "Option Type",
                "loadingDate": "Loading Date",
                "deliveryDate": "Delivery Date",
                "totalAmount": "Total Amount",
                "cargoType": "Cargo Type",
                "quantity": "Quantity",
                "length": "Length",
                "width": "Width",
                "height": "Height",
                "weight": "Weight",
                "optionCode": "Service Code",
                "cost": "Cost",
                "amountInput": "Amount",
                "cargoTimeSlot": "Time Slot"
            },
            "table": {
                "field": "Field",
                "old": "Before",
                "new": "After"
            },
            "status": {
                "added": "Added",
                "removed": "Removed",
                "modified": "Modified"
            }
        },
        "proposals": {
            "table": {
                "proposalColumn": "Proposal",
                "dateColumn": "Date",
                "userColumn": "User",
                "routeColumn": "Route",
                "loadingDateColumn": "Loading date",
                "deliveryDateColumn": "Delivery date",
                "freightColumn": "Freight",
                "statusColumn": "Status"
            },
            "filterByStatus": "Filter by status",
            "statuses": {
                "all": "All statuses",
                "processing": "Processing",
                "awaitingConfirmation": "Awaiting confirmation",
                "confirmed": "Confirmed",
                "cancelled": "Cancelled"
            },
            "buttons": {
                "setPrice": "Set price"
            },
            "setPriceModal": {
                "title": "Set Proposal Price",
                "proposalNumberLbl": "Proposal number",
                "deliveryCostLbl": "Delivery cost (€)",
                "deliveryCostPlaceholder": "Enter cost",
                "commentLbl": "Comment",
                "commentPlaceholder": "Optional comment for the user..."
            }
        },
        "orders": {
            "editOrder": "Edit order",
            "confirmSave": "Are you sure you want to save the changes to this order?",
            "filterByStatus": "Filter by status",
            "filterByTariffType": "Filter by tariff",
            "filterByLoadingType": "Filter by loading type",
            "table": {
                "orderNumber": "Order Number",
                "user": "User",
                "date": "Date",
                "sender": "Sender",
                "recipient": "Recipient",
                "route": "Route",
                "loadingDate": "Loading Date",
                "deliveryDate": "Delivery Date",
                "tariffType": "Tariff",
                "totalAmount": "Amount",
                "loadingType": "Loading",
                "status": "Status",
                "companyPayer": "Payer"
            },
            "statuses": {
                "all": "All statuses",
                "processing": "Processing",
                "confirmed": "Confirmed",
                "scheduledLoading": "Scheduled Loading",
                "loaded": "Loaded",
                "inTransit": "In Transit",
                "customsRegistration": "Customs Registration",
                "delivered": "Delivered",
                "cancelled": "Cancelled"
            },
            "tariffTypes": {
                "all": "All tariffs",
                "standard": "Standard",
                "premium": "Premium",
                "individual": "Individual"
            },
            "loadingTypes": {
                "all": "All loading types",
                "partial": "Partial",
                "full": "Full"
            },
            "cargoTypes": {
                "cardboardBox": "Cardboard Box",
                "euroPallet": "Euro Pallet",
                "palletFin": "Pallet FIN",
                "palletInd": "Pallet IND",
                "other": "Other"
            },
            "bodyTypes": {
                "bus": "Bus",
                "tent": "Tent",
                "tentCurtain": "Tent Curtain",
                "isotherm": "Isotherm",
                "refrigerator": "Refrigerator",
                "flatbed": "Flatbed",
                "flatbedTent": "Flatbed Tent",
                "containerCarrier": "Container Carrier",
                "dumpTruck": "Dump Truck",
                "fullMetalVan": "Full Metal Van",
                "mega": "Mega"
            },
            "loadingMethods": {
                "rear": "Rear",
                "side": "Side",
                "top": "Top"
            },
            "form": {
                "status": "Status",
                "deliveryOption": "Delivery Option",
                "tariffType": "Tariff Type",
                "totalAmount": "Total Amount (€)",
                "loadingDate": "Loading Date",
                "deliveryDate": "Delivery Date",
                "deliveryFrom": "Sender Address",
                "deliveryTo": "Recipient Address",
                "countryCode": "Country Code",
                "countryName": "Country",
                "zip": "ZIP",
                "city": "City",
                "address": "Address",
                "companyName": "Company",
                "contactPerson": "Contact Person",
                "email": "Email",
                "phoneNumber": "Phone",
                "note": "Note",
                "cargo": "Cargo",
                "loadingType": "Loading Type",
                "cargoType": "Cargo Type",
                "quantity": "Quantity",
                "length": "Length",
                "width": "Width",
                "height": "Height",
                "weight": "Weight",
                "bodyType": "Body Type",
                "loadingMethod": "Loading Method",
                "carryingCapacity": "Carrying Capacity",
                "loadingMetersLdm": "Loading Meters (LDM)",
                "cargoAdditional": "Additional Cargo Info",
                "loadingWithTailLift": "Loading with tail lift",
                "adrDangerousGoods": "ADR dangerous goods",
                "cargoDescription": "Cargo description",
                "costOfCargo": "Cost of cargo",
                "costOfCargoCurrency": "Currency",
                "addRecommendedService": "Add service",
                "noServices": "No additional services"
            }
        }
    },
    "mySuggestions": {
        "title": "My Proposals",
        "table": {
            "proposalColumn": "Proposal",
            "dateColumn": "Date",
            "routeColumn": "Route",
            "loadingDateColumn": "Loading date",
            "deliveryDateColumn": "Delivery date",
            "freightColumn": "Freight",
            "additionalServicesColumn": "Additional services",
            "totalColumn": "Total",
            "statusColumn": "Status"
        },
        "buttons": {
            "confirm": "Confirm",
            "cancel": "Cancel",
            "newRequest": "New request"
        },
        "status": {
            "processing": "Processing",
            "awaitingConfirmation": "Awaiting confirmation",
            "confirmed": "Confirmed",
            "cancelled": "Cancelled"
        }
    }
}